import { Coordinate } from './coordinate';

export class BoundingBox {
  max = new Coordinate();
  min = new Coordinate();

  constructor(maxCoordinate, minCoordinate) {
    this.max = maxCoordinate || this.max;
    this.min = minCoordinate || this.min;
  }

  combineWith(boundingBox) {
    this.max.x = Math.max(boundingBox.max.x, this.max.x);
    this.max.y = Math.max(boundingBox.max.y, this.max.y);
    this.min.x = Math.min(boundingBox.min.x, this.min.x);
    this.min.y = Math.min(boundingBox.min.y, this.min.y);
  }
}
